module.exports = __webpack_public_path__ + "img/logo_3.4b3ac9b9.png";